import React from "react";

import { SectionAddress } from "./sectionAddress";
import { SectionContact } from "./sectionContact";
import { SectionPatientConsent } from "./sectionPatientConsent";
import { SectionPatientInfo } from "./sectionPatientInfo";

export const PatientFormLayout: React.FC = () => (
  <div data-testid="patient-form">
    <SectionPatientInfo />
    <SectionAddress />
    <SectionContact />
    <SectionPatientConsent />
  </div>
);
